/*************************************************************************
 *
* c20g CONFIDENTIAL
* __________________
*
*  [2007] - [2023] Counterpoint Consulting, Incorporated
*  All Rights Reserved.
*
* NOTICE:  All information contained herein is, and remains
* the property of Counterpoint Consulting Incorporated.
* The intellectual and technical concepts contained
* herein are proprietary to Counterpoint Consulting Incorporated
* and its suppliers and may be covered by U.S. and Foreign Patents,
* patents in process, and are protected by trade secret or copyright law.
* Dissemination of this information or reproduction of this material
* is strictly forbidden unless prior written permission is obtained
* from Counterpoint Consulting Incorporated.
*/

import cleanUpResponse from '@/util/cleanUpResponse';

export default async function UpdateUserOTDSData(userData) {
    const response = await $.soap({
        body: {
            UpdateUserOTDSData: {
                $xmlns: 'http://dla.mil/ems/bpm/user',
                OTDSUserID: userData.otdsUserId,
                AddedGroups: {
                        Group: userData.addedGroups
                },
                RemovedGroups: {
                        Group: userData.removedGroups
                },
                EDIPI: userData.edipi
            }
        }
    });

    cleanUpResponse(response);
    return response;
}
